import React from 'react';
import { MessageDescriptor, useIntl } from 'react-intl';
import { App } from '@gin-betting/core';
import cn from 'classnames';

import { Icon } from 'components';
import UserDevice from 'services/user-device';
import messages from '../../../messages';

import autorenew from 'assets/svg/autorenew.svg';
import check from 'assets/svg/check.svg';
import chevron from 'assets/svg/chevron.svg';
import cancel from 'assets/svg/close-video.svg';
import './oddIcon.scss';

const glyphMapping: {
    [k in keyof typeof App.BetslipStatus]: any;
} = {
    [App.BetslipStatus.INITIAL]: cancel,
    [App.BetslipStatus.ERROR]: cancel,
    [App.BetslipStatus.PROCESSING]: autorenew,
    [App.BetslipStatus.SUCCESS]: UserDevice.getInstance()?.isDeviceMobile()
        ? chevron
        : check,
};

const iconTitleMapping: {
    [k in keyof typeof App.BetslipStatus]: MessageDescriptor;
} = {
    [App.BetslipStatus.INITIAL]: messages.deleteOdd,
    [App.BetslipStatus.ERROR]: messages.deleteOdd,
    [App.BetslipStatus.PROCESSING]: messages.inProcessing,
    [App.BetslipStatus.SUCCESS]: messages.completed,
};

interface Props {
    status: App.BetslipStatus;
    clickHandler: () => void;
}

const OddIcon: React.FC<Props> = ({ status, clickHandler }) => {
    const { formatMessage } = useIntl();

    const iconGlyph = glyphMapping[status];
    const iconTitle = formatMessage(iconTitleMapping[status]);

    const isProcessing = status === App.BetslipStatus.PROCESSING;
    const isSuccess = status === App.BetslipStatus.SUCCESS;

    return (
        <Icon
            className="__app-OddIcon-container"
            styleName={cn('container', {
                'is-processing': isProcessing,
                'is-completed': isSuccess,
            })}
            glyph={iconGlyph}
            onClick={clickHandler}
            title={iconTitle}
        />
    );
};

export default OddIcon;
